import { memo } from "react";

interface ChatItemProps {
  id: string;
  title: string;
  isActive: boolean;
  onSelect: (id: string) => void;
}

function ChatItem({ id, title, isActive, onSelect }: ChatItemProps) {
  return (
    <button
      onClick={() => onSelect(id)}
      className={`w-full flex items-center justify-between rounded-xl p-3 text-left transition-colors ${
        isActive ? 'bg-blue-200 border border-blue-300' : 'text-slate-700 hover:bg-slate-100'
      }`}
    >
      <div className="flex items-center justify-between text-sm">
        <span className="line-clamp-1">{title}</span>
        {/* {isPinned && <span className="text-xs text-slate-400">📌</span>} */}
      </div>
    </button>
  );
}

export default memo(
  ChatItem,
  (prev, next) =>
    prev.id === next.id &&
    prev.title === next.title &&
    prev.isActive === next.isActive
);
